// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../settings_ctx';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {Root as Article1_root} from './article1';
import {Root as Article2_root} from './article2';

const get_data_id = params=>`/blog/article/slug/${params.slug}/id/${params.id}`;

export const Root = (props: object_of<any>)=>{
    const {theme_name} = useContext(Settings_context);
    if (theme_name=='hola2023')
        return <Article2_root {...props}/>;
    return <Article1_root {...props}/>;
};
Root.meta = {
    ssr_force: true,
    nosearch: true,
    meta: props=>{
        if (props.data_from_provider)
        {
            const {category} = props;
            const seo_data = props.data_from_provider?.data?.seo;
            const seo_title = seo_data?.title ||
                props.data_from_provider?.data?.title;
            const seo_description = seo_data?.description ||
                props.data_from_provider?.data?.excerpt;
            const seo_keywords = seo_data?.keywords || '';
            const seo_date = props.data_from_provider?.data?.datetime?.date;
            return {
                title: 'Hola | ' + seo_title,
                canonical_url: 'https://hola.org/blog/'+category+'/'+
                    props.data_from_provider?.data?.slug,
                og_title: 'Hola | ' + seo_title,
                description: seo_description,
                keywords: seo_keywords,
                og_description: seo_description,
                og_url: 'https://hola.org/blog/'+category+'/'+
                  props.data_from_provider?.data?.slug,
                og_image: props.data_from_provider?.data?.img,
                author: props.data_from_provider?.data?.author?.name,
                published_time: seo_date && new Date(seo_date).toISOString(),
            };
        }
        return {
            title: 'Hola | Article',
            canonical_url: '/blog/article/slug/',
        };
    },
    set_data_cache: (data_cache, params, data)=>{
        data_cache[`/blog/article/slug/${params.slug}/id/${params.id}`] = data;
    },
    get_data_id,
    data_provider: (data_cache, params)=>etask(function*(){
        const cache_key = `/blog/article/slug/${params.slug}/id/${params.id}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        if (!params.id && !params.slug)
            return {data: {}, error: 'article id should be specified'};
        const data = yield fetch(`https://hola.org/cms_api/blog/post/`+
            `?slug=${params.slug}&id=${params.id}`);
        if (!data || data.indexOf && data.indexOf('<!DOCTYPE')>-1)
            return {data: {}, error: 'not found', error_code: 404};
        const end = `https://hola.org/cms_api/blog/posts`;
        let recent_posts = yield fetch(`${end}?posts_per_page=3&paged=0`);
        if (typeof recent_posts!='object')
            recent_posts = {};
        recent_posts = recent_posts.posts||[];
        const result = {
            data,
            recent_posts,
            error: '',
            cache_key,
        };
        data_cache[cache_key] = result;
        return result;
    }),
};
